function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2016, 2026. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import autoBind from 'react-autobind';
import CapabilityController from '../capability-controller';
import commonmessages from '../../../nls/common.properties';
import ConfigHelper from './formUtils.js';
import { ChevronRight, ErrorFilled, Information, WarningAlt } from '@carbon/react/icons';
import { AccordionItem } from '@carbon/react';
import Markdown from '../../common/markdown.jsx';
import ParamDiv from './param-div.jsx';
import PropTypes from 'prop-types';
import React from 'react';
Object.assign = Object.assign || require('object-assign');
var IntegrationDetails = /*#__PURE__*/function (_React$Component) {
  function IntegrationDetails(props) {
    var _this;
    _classCallCheck(this, IntegrationDetails);
    _this = _callSuper(this, IntegrationDetails, [props]);
    _this.state = {
      cap: new CapabilityController(_this.props),
      isFormValid: true
    };
    _this.configHelper = new ConfigHelper(_this);
    _this.innerForm = /*#__PURE__*/React.createRef();
    autoBind(_this);
    return _this;
  }
  _inherits(IntegrationDetails, _React$Component);
  return _createClass(IntegrationDetails, [{
    key: "isHidden",
    value: function isHidden(capability) {
      // The elements you get for free from the catalog (form, description) are implicitly
      // hidden if this capability is visualized by a form element with a custom schema
      var form = capability.__form;
      if (!form || this.props.wizardStep && this.props.wizardStep.hasAdvancedForm()) {
        return false;
      }
      return form && form.schema;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var validForm = this.checkFormValidity();
      this.setState({
        isFormValid: validForm
      });
    }
  }, {
    key: "checkFormValidity",
    value: function checkFormValidity() {
      if (!this.innerForm.current) {
        return false;
      }
      // Check validity of all form inputs within the div
      var inputs = this.innerForm.current.querySelectorAll('input, select, textarea');
      var _iterator = _createForOfIteratorHelper(inputs),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var input = _step.value;
          if (!input.checkValidity()) {
            return false;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return true;
    }
  }, {
    key: "updateFormValidity",
    value: function updateFormValidity() {
      var _this2 = this;
      // timeout needed for form's validity status to update
      setTimeout(function () {
        var validForm = _this2.checkFormValidity();
        _this2.setState({
          isFormValid: validForm
        });
      }, 0);
    }
  }, {
    key: "getDotProperty",
    value: function getDotProperty(name, obj) {
      var index = name.indexOf(".");
      if (index === -1) {
        return obj[name];
      }
      var part = name.substring(0, index);
      return this.getDotProperty(name.substring(index + 1, name.length), obj[part].properties);
    }
  }, {
    key: "mixinForm",
    value: function mixinForm(form, properties) {
      form = form || [];
      properties = properties || {};
      var paramDef;
      return form.map(function (item) {
        if (typeof item === "string" && /[\w+]\.[\w+]/gi.test(item)) {
          paramDef = this.getDotProperty(item, properties);
        } else {
          paramDef = typeof item === "string" ? Object.assign({}, properties[item] || {}, {
            key: item
          }) : Object.assign({}, properties[item.key] || {}, item);
          switch (paramDef.type) {
            case "selectfieldset":
            case "subform":
            case "section":
            case "group":
            case "table":
            case "accordion":
              paramDef.items = this.mixinForm(paramDef.items, properties);
              // Add validation message to table if any item has it
              if (!paramDef.validationMessage) {
                paramDef.items.some(function (i) {
                  paramDef.validationMessage = i.validationMessage;
                  return !!i.validationMessage;
                });
              }
              break;
            case "object":
              var values = Object.keys(paramDef.properties).reduce(function (results, key) {
                return results.concat(paramDef.properties[key]);
              }, []);
              paramDef.items = this.mixinForm(values, properties);
              break;
          }
        }
        return paramDef;
      }.bind(this));
    }
  }, {
    key: "getFieldFeatureFlag",
    value: function getFieldFeatureFlag(fieldId) {
      if (this.state.cap && this.state.cap.schema && this.state.cap.schema.properties && this.state.cap.schema.properties[fieldId]) {
        return this.state.cap.schema.properties[fieldId].featureFlag;
      }
    }
  }, {
    key: "getFieldHidden",
    value: function getFieldHidden(fieldId) {
      var hidden = this.state.cap && this.state.cap.schema && this.state.cap.schema.hidden;
      if (hidden && hidden[this.props.mode] && Array.isArray(hidden[this.props.mode])) {
        return hidden[this.props.mode].includes(fieldId);
      }
      return false;
    }
  }, {
    key: "isFieldHidden",
    value: function isFieldHidden(fieldId) {
      if (this.getFieldHidden(fieldId)) {
        return true;
      }
      var featureFlag = this.getFieldFeatureFlag(fieldId);
      if (featureFlag && this.props.context) {
        return !this.props.context[featureFlag];
      }
      return false;
    }
  }, {
    key: "getCapabilityMode",
    value: function getCapabilityMode() {
      return this.state.cap && this.state.cap.capability && this.state.cap.capability.mode;
    }
  }, {
    key: "isDisabledField",
    value: function isDisabledField(fieldId) {
      return this.props.disabledFields && this.props.disabledFields[fieldId] || false;
    }
  }, {
    key: "renderAccordionItem",
    value: function renderAccordionItem(intDetailsContent) {
      var _this$props$accordion = this.props.accordionProps,
        id = _this$props$accordion.id,
        titleText = _this$props$accordion.titleText;
      var isOpen = false;
      var warningIcon;
      if (this.state.cap.authorizationURI) {
        // Show warning Icon and expand the accordionItem when auth is found to be invalid
        isOpen = true;
        warningIcon = /*#__PURE__*/React.createElement(WarningAlt, {
          className: "warning-icon"
        }, /*#__PURE__*/React.createElement("title", null, commonmessages.get('validator.auth')));
      }

      // Build custom accordion expando button
      var expandoButton = function expandoButton(props) {
        return /*#__PURE__*/React.createElement("button", props, /*#__PURE__*/React.createElement(ChevronRight, {
          className: "cds--accordion__arrow"
        }), warningIcon, /*#__PURE__*/React.createElement("div", {
          className: "cds--accordion__title"
        }, titleText));
      };
      return /*#__PURE__*/React.createElement(AccordionItem, {
        key: titleText,
        id: id,
        title: titleText,
        open: isOpen,
        renderToggle: expandoButton
      }, intDetailsContent);
    }
  }, {
    key: "handleFieldChange",
    value: function handleFieldChange(event) {
      var _event$target;
      if ((event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.setDirty) !== false) {
        this.props.setDirtyFlag();
      }
      var ctrl = this.state.cap;
      ctrl.handleFieldChange(event);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      // workaround https://groups.google.com/d/msg/reactjs/TWhzB1fHrb4/VY5uRPQxvPYJ
      // to avoid children receiving our key
      var childProps = Object.assign({}, this.props);
      delete childProps.key;
      delete childProps.id;
      var ctrl = this.state.cap;
      var ctrlId = ctrl.capability.label;
      // extract out for translation
      var schema = ctrl.schema,
        metadata = ctrl.metadata;
      var formLabel = metadata.displayName || metadata.title;
      var locale = this.props.locale;
      var formAriaLabel = commonmessages.get("label.form.for", [formLabel, ctrlId], locale);
      var wizardStep = this.props.wizardStep;

      //accordionProps only exist for repo's identified as tekton
      if (!this.props.accordionProps) {
        if (!schema || schema.form && schema.form.length === 0 || this.isHidden(this.props.capability, "form")) {
          return /*#__PURE__*/React.createElement("div", null);
        }
      }
      if (childProps.validatorTracker && childProps.validatorTracker.authMap[childProps.selectedType] && !childProps.hideClass) {
        if (!ctrl.authorizationURI && !ctrl.formError) {
          childProps.hideClass = true;
        }
      }
      var intDetailsContent = /*#__PURE__*/React.createElement("div", {
        className: childProps.hideClass ? "form-div hideValidators" : "form-div"
      }, function () {
        if (!_this3.isHidden(_this3.props.capability, "description") && _this3.props.showInfo) {
          var longDescription = wizardStep && wizardStep.getFormLongDescription() || metadata.longDescription || "";
          return /*#__PURE__*/React.createElement(Markdown, {
            id: _this3.props.id,
            className: "long-desc-div",
            content: longDescription
          });
        }
      }(), /*#__PURE__*/React.createElement("div", {
        id: ctrlId,
        ref: this.innerForm,
        "aria-label": formAriaLabel,
        role: "group"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-content-div"
      }, function () {
        if (ctrl.authorizationURI) {
          var schemaProps = schema.properties,
            parameters = _this3.props.capability.metadata.parameters || {};
          if (schema.form) {
            var form = wizardStep && wizardStep.getFormMetadata(schema, {
              authFlow: true
            }) || schema.form;
            var authSchema = _this3.mixinForm(form, schemaProps).map(function (item, i) {
              var _ctrl$parameters;
              var key = item.key || "";
              var paramValue = ((_ctrl$parameters = ctrl.parameters) === null || _ctrl$parameters === void 0 ? void 0 : _ctrl$parameters[key]) || "";
              if (ctrl.capability.mode && ctrl.capability.mode !== 'add' && item.type === "selectfieldset" && !_this3.configHelper.isValidFieldSet(item)) {
                var result = {};
                for (var p in _this3.props.serviceParams) {
                  if (_this3.configHelper.isValidParam(p)) {
                    result[p] = p;
                  }
                }
                var properties = parameters.properties;
                for (var _key in result) {
                  if (properties && properties[_key]) {
                    var tmp = properties[_key];
                    tmp.key = _key;
                    var tmpVal = ctrl.capability.serviceInstance.parameters[_key];
                    if (_this3.isFieldHidden(_key || i)) {
                      return null;
                    }
                    return /*#__PURE__*/React.createElement(ParamDiv, _extends({}, childProps, {
                      key: "form" + (_key || i),
                      disabled: _this3.isDisabledField(_key || i),
                      controller: ctrl,
                      capability: _this3.props.capability,
                      updateFormValidity: _this3.updateFormValidity,
                      onFieldChange: _this3.handleFieldChange,
                      paramDef: tmp,
                      account: _this3.props.account,
                      name: _key,
                      value: tmpVal,
                      isFieldHidden: _this3.isFieldHidden,
                      tcRegions: _this3.props.tcRegions,
                      context: _this3.props.context,
                      toolchainServices: _this3.props.toolchainServices,
                      openSecretsStep: _this3.props.openSecretsStep,
                      hasSecretsStep: _this3.props.hasSecretsStep,
                      hasInvalidSecretsIntegration: _this3.props.hasInvalidSecretIntegration
                    }));
                  }
                }
                return;
              } else {
                if (_this3.isFieldHidden(key || i)) {
                  return null;
                }
                return /*#__PURE__*/React.createElement(ParamDiv, _extends({}, childProps, {
                  key: "form" + (key || i),
                  disabled: _this3.isDisabledField(key || i),
                  controller: ctrl,
                  capability: _this3.props.capability,
                  updateFormValidity: _this3.updateFormValidity,
                  onFieldChange: _this3.handleFieldChange,
                  paramDef: item,
                  name: key,
                  account: _this3.props.account,
                  value: paramValue,
                  isFieldHidden: _this3.isFieldHidden,
                  tcRegions: _this3.props.tcRegions,
                  context: _this3.props.context,
                  toolchainServices: _this3.props.toolchainServices
                }));
              }
            });
            authSchema.push(/*#__PURE__*/React.createElement("div", {
              key: "authPrompt",
              className: "authPrompt"
            }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Information, {
              className: "info-div-left"
            })), /*#__PURE__*/React.createElement("span", null, commonmessages.get("validator.auth"))), /*#__PURE__*/React.createElement("button", {
              className: "authenticate cds--btn cds--btn--primary cds--btn--field",
              type: "button",
              "data-analytics-track": "authorize",
              "data-analytics-label": ctrl.capability.capabilityId,
              onClick: ctrl.handleAuthenticate.bind(ctrl)
            }, commonmessages.get("label.service.authorize"))));
            return authSchema;
          } else {
            return /*#__PURE__*/React.createElement("div", {
              className: "authPrompt"
            }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Information, {
              className: "info-div-left"
            })), /*#__PURE__*/React.createElement("span", null, commonmessages.get("validator.auth"))), /*#__PURE__*/React.createElement("button", {
              className: "authenticate cds--btn cds--btn--primary cds--btn--field",
              type: "button",
              "data-analytics-track": "authorize",
              "data-analytics-label": ctrl.capability.capabilityId,
              onClick: ctrl.handleAuthenticate.bind(ctrl)
            }, commonmessages.get("label.service.authorize")));
          }
        } else if (ctrl.formError) {
          // An unexpected error has been received from the validator. Show the error and
          // a 'Retry' button to give the user a retry option.
          var _schemaProps = schema.properties;
          var errorSchema = [];
          if (schema.form) {
            var _form = wizardStep && wizardStep.getFormMetadata(schema) || schema.form;
            errorSchema = _this3.mixinForm(_form, _schemaProps).map(function (item, i) {
              var _ctrl$parameters2;
              // Render only the validator component as we're gonna need it when the user
              // clicks the 'Retry' button.
              if (item.type !== "validator") {
                return null;
              }
              var key = item.key || "";
              var paramValue = ((_ctrl$parameters2 = ctrl.parameters) === null || _ctrl$parameters2 === void 0 ? void 0 : _ctrl$parameters2[key]) || "";
              return /*#__PURE__*/React.createElement(ParamDiv, _extends({}, childProps, {
                ariaLabelledby: _this3.props.id,
                disabled: _this3.isDisabledField(key || i),
                key: "form" + (key || i),
                controller: ctrl,
                capability: _this3.props.capability,
                updateFormValidity: _this3.updateFormValidity,
                onFieldChange: ctrl.handleFieldChange.bind(ctrl),
                paramDef: item,
                name: key,
                account: _this3.props.account,
                value: paramValue,
                isFieldHidden: _this3.isFieldHidden,
                tcRegions: _this3.props.tcRegions,
                context: _this3.props.context,
                toolchainServices: _this3.props.toolchainServices
              }));
            });
          }

          // Render the error and the 'Retry' button
          errorSchema.push(/*#__PURE__*/React.createElement("div", {
            key: "formError",
            className: "formError"
          }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(ErrorFilled, {
            className: "info-div-left"
          })), /*#__PURE__*/React.createElement("span", null, commonmessages.get("validator.error"))), /*#__PURE__*/React.createElement("div", {
            className: "message"
          }, ctrl.formError), /*#__PURE__*/React.createElement("button", {
            className: "retry cds--btn cds--btn--primary cds--btn--field",
            type: "button",
            onClick: ctrl.restart.bind(ctrl)
          }, commonmessages.get("validator.retry"))));
          return errorSchema;
        } else {
          var _schemaProps2 = schema.properties;
          if (schema.form) {
            var _form2 = wizardStep && wizardStep.getFormMetadata(schema) || schema.form;
            return _this3.mixinForm(_form2, _schemaProps2).map(function (item, i) {
              var _ctrl$parameters3;
              var key = item.key || "";
              var paramValue = ((_ctrl$parameters3 = ctrl.parameters) === null || _ctrl$parameters3 === void 0 ? void 0 : _ctrl$parameters3[key]) || "";
              if (ctrl.capability.mode && ctrl.capability.mode !== 'add' && item.type === "selectfieldset" && !_this3.configHelper.isValidFieldSet(item)) {
                var result = {};
                for (var p in _this3.props.serviceParams) {
                  if (_this3.configHelper.isValidParam(p)) {
                    result[p] = p;
                  }
                }
                var _parameters = _this3.props.capability.metadata.parameters || {},
                  properties = _parameters.properties;
                for (var _key2 in result) {
                  if (properties && properties[_key2]) {
                    var tmp = properties[_key2];
                    tmp.key = _key2;
                    var tmpVal = ctrl.capability.serviceInstance.parameters[_key2];
                    if (_this3.isFieldHidden(_key2 || i)) {
                      return null;
                    }
                    return /*#__PURE__*/React.createElement(ParamDiv, _extends({}, childProps, {
                      ariaLabelledby: _this3.props.id,
                      disabled: _this3.isDisabledField(_key2 || i),
                      key: "form" + (_key2 || i),
                      controller: ctrl,
                      capability: _this3.props.capability,
                      updateFormValidity: _this3.updateFormValidity,
                      onFieldChange: _this3.handleFieldChange,
                      paramDef: tmp,
                      account: _this3.props.account,
                      name: _key2,
                      value: tmpVal,
                      isFieldHidden: _this3.isFieldHidden,
                      tcRegions: _this3.props.tcRegions,
                      context: _this3.props.context,
                      toolchainServices: _this3.props.toolchainServices
                    }));
                  }
                }
                return;
              } else {
                if (_this3.isFieldHidden(key || i)) {
                  return null;
                }
                return /*#__PURE__*/React.createElement(ParamDiv, _extends({}, childProps, {
                  ariaLabelledby: _this3.props.id,
                  disabled: _this3.isDisabledField(key || i),
                  key: "form" + (key || i),
                  controller: ctrl,
                  capability: _this3.props.capability,
                  updateFormValidity: _this3.updateFormValidity,
                  onFieldChange: _this3.handleFieldChange,
                  paramDef: item,
                  name: key,
                  account: _this3.props.account,
                  value: paramValue,
                  isFieldHidden: _this3.isFieldHidden,
                  tcRegions: _this3.props.tcRegions,
                  context: _this3.props.context,
                  toolchainServices: _this3.props.toolchainServices
                }));
              }
            });
          } else {
            return Object.keys(_schemaProps2).map(function (name) {
              if (_this3.isFieldHidden(name)) {
                return null;
              }
              return /*#__PURE__*/React.createElement(ParamDiv, _extends({}, childProps, {
                ariaLabelledby: _this3.props.id,
                disabled: _this3.isDisabledField(name),
                key: "schema" + name,
                controller: ctrl,
                capability: _this3.props.capability,
                updateFormValidity: _this3.updateFormValidity,
                onFieldChange: _this3.handleFieldChange,
                paramDef: _schemaProps2[name],
                name: name,
                account: _this3.props.account,
                value: ctrl.parameters[name] || "",
                isFieldHidden: _this3.isFieldHidden,
                tcRegions: _this3.props.tcRegions,
                context: _this3.props.context,
                toolchainServices: _this3.props.toolchainServices
              }));
            });
          }
        }
      }())));
      if (this.props.accordionProps) {
        // For tekton repos, use accordion rendering
        return this.renderAccordionItem(intDetailsContent);
      }
      return intDetailsContent;
    }
  }]);
}(React.Component);
_defineProperty(IntegrationDetails, "defaultProps", {
  showInfo: true
});
export { IntegrationDetails as default };
IntegrationDetails.propTypes = {
  locale: PropTypes.string.isRequired,
  userInfo: PropTypes.object
};